import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Recommend from "./components/Recommend";
import Scenarios from "./components/Scenarios";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import About from "./components/About";
import Cta from "./components/Cta";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <Features />
      <Recommend />
      <Scenarios />
      <Testimonials />
      <Faq />
      <About />
      <Cta />
      <Footer />
    </main>
  );
}